import { useState } from 'react';
import styled from 'styled-components';
import { useInterval } from '../../../../hooks/external/use-interval';
import Logo from './logo.svg';
import { SpinningCircle } from './spinning-circle';

export enum BouSpinnerSize {
  XSMALL,
  SMALL,
  MEDIUM,
  LARGE,
}

export interface SpinnerProps {
  size?: BouSpinnerSize;
  className?: string;
  showLogo?: boolean;
  showAlways?: boolean;
}

function toPixelSize(size: BouSpinnerSize) {
  switch (size) {
    case BouSpinnerSize.LARGE:
      return 100;
    case BouSpinnerSize.MEDIUM:
      return 60;
    case BouSpinnerSize.SMALL:
      return 40;
    case BouSpinnerSize.XSMALL:
      return 20;
  }
}

export function BouSpinner(props: SpinnerProps) {
  const size = toPixelSize(props.size !== undefined ? props.size : BouSpinnerSize.MEDIUM);
  const imageWidth = size / 2;
  const imageHeight = (imageWidth * 52) / 88;

  // only show spinner after 100 ms to prevent quick
  // flicker the loading spinner
  const [timeoutExpired, setTimeoutExpired] = useState(false);
  useInterval(() => {
    setTimeoutExpired(true);
  }, 100);

  const opacity = timeoutExpired || props.showAlways ? 1 : 0;
  return (
    <Root className={props.className} style={{ opacity }}>
      <CircleWrap>
        <SpinningCircle size={size} />
      </CircleWrap>
      {props.showLogo && (
        <ImageWrap>
          <StyledLogo style={{ width: imageWidth, height: imageHeight }} viewBox="0 0 88 52" />
        </ImageWrap>
      )}
    </Root>
  );
}

const Root = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;

const CircleWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ImageWrap = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLogo = styled(Logo)`
  display: block;
`;
